<style src="css/consult.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem; padding-bottom: 1rem">
    <img class="logo" src="../assets/common/logo.png" />
    <div class="topBox">咨询</div>
    <div class="box">
      <div class="mode">
        <div class="left">
          <div class="leftIcon s1"></div>
          线下咨询
        </div>
        <div class="right">
          <div class="rightItem" @click="to(`psychology?current=1`)" v-if="offlineData[0] != undefined">
            <div class="num" :class="{ active: offlineData[0].totalCount }">
              {{ offlineData[0].totalCount }}
            </div>
            <div class="name">待咨询</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=2`)" v-if="offlineData[1] != undefined">
            <div class="num" :class="{ active1: offlineData[1].totalCount }">
              {{ offlineData[1].totalCount }}
            </div>
            <div class="name">进行中</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=3`)" v-if="offlineData[2] != undefined">
            <div class="num">{{ offlineData[2].totalCount }}</div>
            <div class="name">已完成</div>
          </div>
        </div>
      </div>
      <div class="mode">
        <div class="left">
          <div class="leftIcon s2"></div>
          视频咨询
        </div>
        <div class="right">
          <div class="rightItem" @click="to(`psychology?current=1`)" v-if="videoData[0] != undefined">
            <div class="num" :class="{ active: videoData[0].totalCount }">
              {{ videoData[0].totalCount }}
            </div>
            <div class="name">待咨询</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=2`)" v-if="videoData[1] != undefined">
            <div class="num" :class="{ active1: videoData[1].totalCount }">
              {{ videoData[1].totalCount }}
            </div>
            <div class="name">进行中</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=3`)" v-if="videoData[2] != undefined">
            <div class="num">{{ videoData[2].totalCount }}</div>
            <div class="name">已完成</div>
          </div>
        </div>
      </div>
      <div class="mode">
        <div class="left">
          <div class="leftIcon s3"></div>
          语音咨询
        </div>
        <div class="right">
          <div class="rightItem" @click="to(`psychology?current=1`)" v-if="telephoneData[0] != undefined">
            <div class="num" :class="{ active: telephoneData[0].totalCount }">
              {{ telephoneData[0].totalCount }}
            </div>
            <div class="name">待咨询</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=2`)" v-if="telephoneData[1] != undefined">
            <div class="num" :class="{ active1: telephoneData[1].totalCount }">
              {{ telephoneData[1].totalCount }}
            </div>
            <div class="name">进行中</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=3`)" v-if="telephoneData[2] != undefined">
            <div class="num">{{ telephoneData[2].totalCount }}</div>
            <div class="name">已完成</div>
          </div>
        </div>
      </div>
      <div class="mode">
        <div class="left">
          <div class="leftIcon s4"></div>
          图文咨询
        </div>
        <div class="right">
          <div class="rightItem" @click="to(`psychology?current=1`)" v-if="imageTextData[0] != undefined">
            <div class="num" :class="{ active: imageTextData[0].totalCount }">
              {{ imageTextData[0].totalCount }}
            </div>
            <div class="name">待咨询</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=2`)" v-if="imageTextData[1] != undefined">
            <div class="num" :class="{ active1: imageTextData[1].totalCount }">
              {{ imageTextData[1].totalCount }}
            </div>
            <div class="name">进行中</div>
          </div>
          <div class="rightItem" @click="to(`psychology?current=3`)" v-if="imageTextData[2] != undefined">
            <div class="num">{{ imageTextData[2].totalCount }}</div>
            <div class="name">已完成</div>
          </div>
        </div>
      </div>
    </div>
    <footerBox active="2"></footerBox>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import footerBox from "components/footer";
import moment from "moment/moment";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      imageTextData: [],
      offlineData: [],
      telephoneData: [],
      videoData: [],
    };
  },
  components: {
    noMoreData,
    topbar,
    footerBox,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    to(n) {
      this.$router.push(`/${n}`);
    },
    async getDoctorServeDatas() {
      let data = await getSources(
        "/bear-scale/api/chatDoctor/getDoctorServeDatas.json",
        { doctorId: localStorage.getItem("doctorId") }
      );
      if (data.status === 0) {
        this.imageTextData = data.imageTextData;
        this.offlineData = data.offlineData;
        this.telephoneData = data.telephoneData;
        this.videoData = data.videoData;
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {},
  mounted() {
    this.getDoctorServeDatas();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/consult.vue